import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// helpers
import {
  addFaq as addFaqApi,
  updateFaq as updateFaqApi,
  getFaq as getFaqApi,
  deleteFaq as deleteFaqApi,
} from "../../helpers";

// actions
import {
  faqApiResponseSuccess,
  faqApiResponseError,
  getFaq,
} from "./actions";

// constants
import { FaqActionTypes } from "./constants";

interface newsData {
  payload: {
    id: number;
    question_en: string,
    question_ar: string,
    answer_en: string,
    answer_ar: string
  };
  type: string;
}

function* createFaq({
  payload: { question_en, question_ar, answer_en, answer_ar },
  type,
}: newsData): SagaIterator {
  try {
    const response = yield call(addFaqApi, {
      question_en, question_ar, answer_en, answer_ar
    });

    const newsData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(faqApiResponseSuccess(FaqActionTypes.CREATE_FAQ, newsData));
    yield put(getFaq());
  } catch (error: any) {
    yield put(faqApiResponseError(FaqActionTypes.CREATE_FAQ, error));
  }
}

function* updateFaq({
  payload: { id, question_en, question_ar, answer_en, answer_ar },
}: newsData): SagaIterator {
  try {
    const response = yield call(updateFaqApi, id, {
      question_en, question_ar, answer_en, answer_ar
    });
    const newsData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(faqApiResponseSuccess(FaqActionTypes.UPDATE_FAQ, newsData));
    yield put(getFaq());
  } catch (error: any) {
    yield put(faqApiResponseError(FaqActionTypes.UPDATE_FAQ, error));
  }
}

function* getFaqs(): SagaIterator {
  try {
    const response = yield call(getFaqApi);
    const newsData = response?.data?.faqs;

    yield put(faqApiResponseSuccess(FaqActionTypes.GET_FAQ, newsData));
  } catch (error: any) {
    yield put(faqApiResponseError(FaqActionTypes.GET_FAQ, error));
  }
}

function* deleteFaq({ payload: { id } }: newsData): SagaIterator {
  try {
    const response = yield call(deleteFaqApi, id);
    const newsData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(faqApiResponseSuccess(FaqActionTypes.DELETE_FAQ, newsData));
    yield put(getFaq());
  } catch (error: any) {
    yield put(faqApiResponseError(FaqActionTypes.DELETE_FAQ, error));
  }
}

export function* watchCreateFaq() {
  yield takeEvery(FaqActionTypes.CREATE_FAQ, createFaq);
}
export function* watchUpdateFaq() {
  yield takeEvery(FaqActionTypes.UPDATE_FAQ, updateFaq);
}
export function* watchGetFaq() {
  yield takeEvery(FaqActionTypes.GET_FAQ, getFaqs);
}

export function* watchDeleteFaq() {
  yield takeEvery(FaqActionTypes.DELETE_FAQ, deleteFaq);
}

function* faqSaga() {
  yield all([
    fork(watchCreateFaq),
    fork(watchUpdateFaq),
    fork(watchDeleteFaq),
    fork(watchGetFaq),
  ]);
}

export default faqSaga;
